import React from 'react';

import {
  AdminPaginationText,
  AdminPaginationNavButton,
  AdminPaginationEllipsis,
} from '../../../sections/AdminDashboard/shared/adminUx';

/** Admin list pagination — §8 pagination UI (12px / 500). */
export default function ConfigurationListPaginationFooter({
  show,
  rangeStart,
  rangeEnd,
  totalCount,
  currentPage,
  totalPages,
  onPrev,
  onNext,
  goToPage,
}) {
  if (!show) return null;

  return (
    <div className="relative flex items-center mt-6 px-4" data-admin-pagination="">
      <div className="absolute left-4">
        <AdminPaginationText className="text-mediumgray">
          Showing {rangeStart}-{rangeEnd} out of {totalCount}
        </AdminPaginationText>
      </div>
      <div className="flex-1 flex items-center justify-center">
        <div className="flex items-center gap-2">
          <AdminPaginationNavButton onClick={onPrev} disabled={currentPage === 1}>
            Previous
          </AdminPaginationNavButton>
          {[...Array(totalPages)].map((_, index) => {
            const pageNum = index + 1;
            const showPage =
              pageNum === 1 ||
              pageNum === totalPages ||
              (pageNum >= currentPage - 1 && pageNum <= currentPage + 1);

            if (!showPage) {
              const prevPage = currentPage - 2;
              const nextPage = currentPage + 2;
              if (
                (pageNum === prevPage && currentPage > 3) ||
                (pageNum === nextPage && currentPage < totalPages - 2)
              ) {
                return <AdminPaginationEllipsis key={pageNum} />;
              }
              return null;
            }

            return (
              <AdminPaginationNavButton
                key={pageNum}
                onClick={() => goToPage(pageNum)}
                active={currentPage === pageNum}
              >
                {pageNum}
              </AdminPaginationNavButton>
            );
          })}
          <AdminPaginationNavButton onClick={onNext} disabled={currentPage === totalPages}>
            Next
          </AdminPaginationNavButton>
        </div>
      </div>
    </div>
  );
}
